import { render, staticRenderFns } from "./TrainingParticipantBulkModal.vue?vue&type=template&id=1056970e"
import script from "./TrainingParticipantBulkModal.vue?vue&type=script&lang=js"
export * from "./TrainingParticipantBulkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports